<template>
  <v-container fluid>Dashboard</v-container>
</template>

<script>
export default {
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Dashboard"
    });
  }
};
</script>
